import { get, patch, put, del } from "../../api_helper";
import * as url from "../../url_helper";
import { convertObjectToParams } from "utils";

// FAQ (よくある質問) - master data đa ngôn ngữ (ja/ko/zh/en).
// Chỉ super admin (account 000000) được thêm/sửa/xóa; mọi client (web + mobile) đọc chung.
export const apiGetFaqs = (data) => {
  let urlApi = url.API_FAQ;
  if (data) {
    const params = convertObjectToParams(data);
    urlApi = urlApi + "?" + params;
  }
  return get(urlApi);
};
export const apiPutFaq = (data) => put(url.API_FAQ, data);
export const apiPatchFaq = (id, data) => patch(url.API_FAQ + id, data);
export const apiDelFaq = (id) => del(url.API_FAQ + id);
